import { useEffect } from 'react';

const QualtricsRefreshForm = () => {
  useEffect(() => {
    sessionStorage.setItem('qualtrics_formid', 'refresh');
  }, []);

  return <></>;
};

export default QualtricsRefreshForm;
